import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Button, Paragraph, Progress, Slider, XStack, YStack } from "tamagui";
function ProgressDemo() {
  const [size, setSize] = useState(4);
  const [progress, setProgress] = useState(20);
  const sizeProp = `$${size}`;
  useEffect(() => {
    const timer = setTimeout(() => setProgress(60), 1e3);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(YStack, { height: 60, alignItems: "center", space: true, children: [
      /* @__PURE__ */ jsxs(Paragraph, { height: 30, opacity: 0.5, children: [
        "Size: ",
        size
      ] }),
      /* @__PURE__ */ jsx(Progress, { size: sizeProp, value: progress, children: /* @__PURE__ */ jsx(Progress.Indicator, { animation: "bouncy" }) })
    ] }),
    /* @__PURE__ */ jsxs(
      XStack,
      {
        alignItems: "center",
        space: true,
        position: "absolute",
        bottom: "$3",
        left: "$4",
        $xxs: { display: "none" },
        children: [
          /* @__PURE__ */ jsxs(
            Slider,
            {
              size: "$2",
              width: 130,
              defaultValue: [4],
              min: 2,
              max: 6,
              step: 1,
              onValueChange: ([val]) => {
                setSize(val);
              },
              children: [
                /* @__PURE__ */ jsx(Slider.Track, { borderWidth: 1, borderColor: "$color5", children: /* @__PURE__ */ jsx(Slider.TrackActive, {}) }),
                /* @__PURE__ */ jsx(Slider.Thumb, { circular: true, index: 0 })
              ]
            }
          ),
          /* @__PURE__ */ jsx(Button, { size: "$2", onPress: () => setProgress((prev) => (prev + 20) % 100), children: "Load" })
        ]
      }
    )
  ] });
}
export {
  ProgressDemo
};
//# sourceMappingURL=ProgressDemo.js.map
